import { Controller } from "@hotwired/stimulus"
import { MetaVars } from "../lib/helpers"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  static values = {
    placement: String
  }
  connect() {
    this.setupTooltip()
  }

  disconnect() {
    this.visibilityObserver?.disconnect()
    bootstrap.Tooltip.getInstance(this.element)?.dispose()
  }

  // Called on turbo:before-cache so a shown tip isn't baked into the snapshot
  teardown() {
    bootstrap.Tooltip.getInstance(this.element)?.hide()
  }

  setupTooltip() {
    if (MetaVars.envTest) return

    const tooltip = new bootstrap.Tooltip(this.element, {
      placement: this.placementValue,
      html: true
    })

    // A trigger hidden while its tip is shown (e.g. the expand icon gets
    // d-none on click) never fires mouseleave, so Bootstrap leaves the tip
    // stuck on screen. Watch the trigger while shown and hide the tip the
    // moment the trigger is no longer visible.
    this.visibilityObserver = new IntersectionObserver(entries => {
      if (entries.some(entry => !entry.isIntersecting)) tooltip.hide()
    })
    this.element.addEventListener("shown.bs.tooltip", () => this.visibilityObserver.observe(this.element))
    this.element.addEventListener("hidden.bs.tooltip", () => this.visibilityObserver.unobserve(this.element))
  }
}
